import { Observable, Subscription } from 'rxjs';
import { Directive, Input } from '@angular/core';
import { Validator, AbstractControl, NG_ASYNC_VALIDATORS } from '@angular/forms';
import { HttpClient, HttpParams } from '@angular/common/http';
@Directive({
  selector:
    '[serverValidate][formControlName],[serverValidate][formControl],[serverValidate][ngModel]',
  providers: [{ provide: NG_ASYNC_VALIDATORS, useExisting: ServerValidator, multi: true }],
})
export class ServerValidator implements Validator {
  timer: any = null;
  request: Subscription = null;

  @Input() serverValidate: string;
  @Input() queryParams: any;

  constructor(private http: HttpClient) {}

  validate(
    c: AbstractControl,
  ): Promise<{ [key: string]: any }> | Observable<{ [key: string]: any }> {
    return new Promise<{ [key: string]: any }>((resolve) => {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      if (this.request) {
        this.request.unsubscribe();
        this.request = null;
      }

      if (c.value) {
        this.timer = setTimeout(() => {
          this.timer = null;
          var params = new HttpParams();
          params = params.set('value', c.value);
          Object.keys(this.queryParams).forEach((key) => {
            params = params.set(key, this.queryParams[key]);
          });

          this.request = this.http
            .get(this.serverValidate, { responseType: 'text', params: params })
            .subscribe((value) => {
              resolve(
                value == 'true'
                  ? null
                  : {
                      serverValidate: true,
                    },
              );
            });
        }, 300);
      }
    });
  }
}
